import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CourseProvider } from "./lib/CourseContext";
import { UserProvider } from "./lib/UserContext";
import { MyThemeProvider } from "./themes/ElacTheme";

ReactDOM.render(
  <UserProvider>
    <CourseProvider>
      <MyThemeProvider>
        <App />
      </MyThemeProvider>
    </CourseProvider>
  </UserProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
